export default __webpack_public_path__ + "static/media/659.93e15191.png";